import logo from "../Images/Plus credit logo.jpg";
import whatsapp from '../Images/whatsapp.png';
import instagram from '../Images/instagram.png';
import facebook from '../Images/facebook.png';
import Checkoff from '../Images/Checkoff.png';
import globus from '../Images/globus.png';
import Parallax from '../Images/Parallax.jpg';
import Watu from '../Images/Watu.png';
import zenith from '../Images/zenith.png';
import { NavLink } from "react-router-dom";


export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-left">
                <img src={logo} alt="logo of PlusCredit" className="footimage" />
                <p className="footer-leftp">
                    PlusCredit is committed to delivering fast, digital-first, and user-friendly financial services that work around your lifestyle. Whether you’re saving, shopping, or investing, we ensure a smooth, secure experience backed by trusted partners and a vibrant affiliate network.Our promise is real value, no stress, and support that always shows up.
                </p>

                <div className="social-icons">
                   <NavLink to= "https://wa.me/message/4LW6QYJ6FXCYD1"> <img className="icon" src={whatsapp} alt="Whatsapp icon" /> </NavLink>
                    <NavLink to="https://www.instagram.com/pluscredit_affiliates?igsh=MW4yMDN2Yjc1ZnA3YQ=="><img className="icon" src={instagram} alt="Instagram icon" /> </NavLink>
                    <NavLink to="https://www.facebook.com/share/1EWWAEQgjv/"><img className="icon" src={facebook} alt="Facebook icon" /> </NavLink>
                </div>
            </div>

            <div className="footer-right">
                <h3>Partners</h3>
                <div className="partner-logos">
                    <div className="partner">
                        <span>Zenith</span>
                        <img className="logo" src={zenith} alt="zenith logo" />
                    </div>
                    <div className="partner">
                        <span>Watu</span>
                        <img className="logo" src={Watu} alt="watu logo" />
                    </div>
                    <div className="partner">
                        <span>Globus Bank</span>
                        <img className="logo" src={globus} alt="globus bank logo" />
                    </div>
                    <div className="partner">
                        <span>Parallex Bank</span>
                        <img className="logo" src={Parallax} alt="parallex bank logo" />
                    </div>
                    <div className="partner">
                        <span>Checkoff</span>
                        <img className="logo" src={Checkoff} alt="checkoff logo" />
                    </div>
                </div>
            </div>
        </footer>
    );
}
